import { Typography } from '@mui/material';
import { colors } from '../../styles/fontStyles';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider.js';

type TextWithPrimaryBlueBackgroundProps = {
  textContent: string;
  sxProps?: Record<string, unknown>;
  additionalProps?: Record<string, unknown>;
};

const TextWithPrimaryBlueBackground: React.FC<TextWithPrimaryBlueBackgroundProps> = ({
  textContent,
  sxProps,
  additionalProps,
}) => {
  const { theme } = useThemeContext();

  return (
    <Typography
      sx={{
        background: theme.custom.components.textWithPrimaryBlueBackground.background,
        color: theme.custom.components.textWithPrimaryBlueBackground.color,
        padding: '0 4px',
        width: 'fit-content',
        ...sxProps,
      }}
      {...additionalProps}
    >
      {textContent}
    </Typography>
  );
};

export default TextWithPrimaryBlueBackground;
